var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: { subtitle: "Operation logs for continuous data API." },
      }),
      _vm._v(" "),
      _c("AquariusServerStatus"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("Subheader", { attrs: { title: "Aquarius Logs", "no-search": "" } }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", lg6: "" } },
                            [
                              _c("DateRange", {
                                attrs: {
                                  rounded: "",
                                  solo: "",
                                  minDate: _vm.MinDate,
                                  maxDate: _vm.MaxDate,
                                  availableDateRange: {
                                    start: _vm.MinDate,
                                    end: _vm.MaxDate,
                                  },
                                  "min-max-placeholder":
                                    _vm.formats.prettyDateFormat,
                                  shortcuts: _vm.shortcuts,
                                  "no-arrows": "",
                                  data: _vm.availableData,
                                  showAvailableText: false,
                                },
                                model: {
                                  value: _vm.dates,
                                  callback: function ($$v) {
                                    _vm.dates = $$v
                                  },
                                  expression: "dates",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "pa-1",
                              attrs: { xs12: "", lg6: "" },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  outline: "",
                                  label: "Aquarius Server",
                                  items: _vm.serverItem,
                                  "hide-details": "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.selectServer,
                                  callback: function ($$v) {
                                    _vm.selectServer = $$v
                                  },
                                  expression: "selectServer",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pa-1",
                              attrs: { xs12: "", lg6: "" },
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  outline: "",
                                  label: "API Endpoint",
                                  items: _vm.apiItem,
                                  "hide-details": "",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.selectAPIEndpoint,
                                  callback: function ($$v) {
                                    _vm.selectAPIEndpoint = $$v
                                  },
                                  expression: "selectAPIEndpoint",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "pa-1",
                              attrs: { xs12: "", lg12: "" },
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  outline: "",
                                  label: "Enter Search term",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.queryString,
                                  callback: function ($$v) {
                                    _vm.queryString = $$v
                                  },
                                  expression: "queryString",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-checkbox", {
                                attrs: { label: "Errors only" },
                                model: {
                                  value: _vm.errorsOnly,
                                  callback: function ($$v) {
                                    _vm.errorsOnly = $$v
                                  },
                                  expression: "errorsOnly",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.selectLogs()
                              _vm.page = 1
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("search"),
                          ]),
                          _vm._v("Search\n          "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { color: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.clearAll()
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("autorenew"),
                          ]),
                          _vm._v("Clear All\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.searchLoading
                    ? _c(
                        "div",
                        [
                          _c("br"),
                          !_vm.searchFinish
                            ? _c("v-progress-linear", {
                                attrs: { indeterminate: true },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm.searchFinish
                    ? _c(
                        "v-card-text",
                        [
                          _c("v-subheader", [_vm._v("Filters:")]),
                          _vm._v(" "),
                          _c(
                            "v-chip",
                            {
                              staticStyle: { "margin-left": "15px" },
                              attrs: { disabled: "" },
                            },
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("bookmark"),
                              ]),
                              _vm._v(
                                "Date Time: " +
                                  _vm._s(_vm.selectItem.showDateTime)
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.selectItem.selectServer
                            ? _c(
                                "v-chip",
                                {
                                  staticStyle: { "margin-left": "15px" },
                                  attrs: { disabled: "" },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("bookmark")]
                                  ),
                                  _vm._v(
                                    "Server: " +
                                      _vm._s(_vm.selectItem.selectServer)
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectItem.selectAPIEndpoint
                            ? _c(
                                "v-chip",
                                {
                                  staticStyle: { "margin-left": "15px" },
                                  attrs: { disabled: "" },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("bookmark")]
                                  ),
                                  _vm._v(
                                    "API Endpoint: " +
                                      _vm._s(_vm.selectItem.selectAPIEndpoint)
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectItem.errorsOnly
                            ? _c(
                                "v-chip",
                                {
                                  staticStyle: { "margin-left": "15px" },
                                  attrs: { disabled: "" },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("bookmark")]
                                  ),
                                  _vm._v(
                                    "Errors Only: " +
                                      _vm._s(_vm.selectItem.errorsOnly)
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.selectItem.queryString
                            ? _c(
                                "v-chip",
                                {
                                  staticStyle: { "margin-left": "15px" },
                                  attrs: { disabled: "" },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("bookmark")]
                                  ),
                                  _vm._v(
                                    "Search Term: " +
                                      _vm._s(_vm.selectItem.queryString)
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-subheader", [_vm._v("Results:")]),
                          _vm._v(" "),
                          _c(
                            "v-chip",
                            {
                              staticStyle: { "margin-left": "15px" },
                              attrs: { disabled: "" },
                            },
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("pageview"),
                              ]),
                              _vm._v(_vm._s(_vm.logsNum) + " Logs"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-expansion-panel",
                            { attrs: { focusable: "" } },
                            _vm._l(_vm.searchResults, function (item, i) {
                              return _c(
                                "v-expansion-panel-content",
                                {
                                  key: i,
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass: "word_wrap",
                                                    attrs: { xs3: "" },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color:
                                                            item.Level.toLowerCase(),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.Level.toLowerCase()
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " Level: " +
                                                        _vm._s(item.Level)
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass: "word_wrap",
                                                    attrs: { xs3: "" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "DateTime: " +
                                                        _vm._s(
                                                          _vm.showResultsTime(
                                                            item.DateTime
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass: "word_wrap",
                                                    attrs: { xs3: "" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Server: " +
                                                        _vm._s(
                                                          item.AquariusServer
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        {
                                          staticClass: "grey lighten-3",
                                          class: _vm.result_theme(
                                            item.Level.toLowerCase()
                                          ),
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs2: "" } },
                                                [_vm._v("Tenant:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "word_wrap",
                                                  attrs: { xs10: "" },
                                                },
                                                [_vm._v(_vm._s(item.Tenant))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs2: "" } },
                                                [_vm._v("Request Data:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "word_wrap",
                                                  attrs: { xs10: "" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.RequestData)
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                { attrs: { xs2: "" } },
                                                [_vm._v("Notes:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "word_wrap",
                                                  attrs: { xs10: "" },
                                                },
                                                [_vm._v(_vm._s(item.Notes))]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-xs-center" },
                            [
                              _c("v-pagination", {
                                attrs: {
                                  length: _vm.pageLength,
                                  "total-visible": 7,
                                },
                                model: {
                                  value: _vm.page,
                                  callback: function ($$v) {
                                    _vm.page = $$v
                                  },
                                  expression: "page",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "app-confirmation-modal",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.searchError,
            callback: function ($$v) {
              _vm.searchError = $$v
            },
            expression: "searchError",
          },
        },
        [
          _c("template", { slot: "app-modal-title" }, [_vm._v("ERROR")]),
          _vm._v(" "),
          _c("template", { slot: "app-modal-text" }, [
            _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "app-modal-actions" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", outline: "" },
                  on: {
                    click: function ($event) {
                      _vm.searchError = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }